let subscribers = {};
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  sectionRefreshed: 'section-refreshed',
};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/*
 * Shopify Common JS
 *
 */

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
}; 

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/**
 * Deffered media used to load the media on intection
 */
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


/**
* Website Overlay for Mobile Menu and Cart Drawer
*/
class siteOverlay extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('site-overlay').classList.add('overlay-body');
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    document.querySelector('site-overlay').classList.remove('overlay-body');
    document.body.classList.remove('scroll-fixed');
    document.querySelector('cart-drawer')?.classList.remove('active');
    document.querySelector('.mobile-nav-wrapper')?.classList.remove('drawer-active');
    document.querySelector('#closeMobileNavDrawer')?.dispatchEvent(new Event('click'));
    document.querySelector('predictive-search')?.closeSearchBar();
    document.querySelector('localization-drawer')?.closeDrawer();
    document.querySelector('site-overlay').dispatchEvent(new Event('overlay:hide'));
  }
}
customElements.define("site-overlay", siteOverlay);

/**
 * Modal Dialogue
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = document.querySelectorAll('[data-modal-opener="'+this.id+'"]');
  }

  connectedCallback() {
    if(this.modalOpeners.length > 0) {
      this.modalOpeners.forEach((opener)=>{
        opener.addEventListener('click', ()=>{
          this.show(opener);
        });
      });
    }

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (evt) => {
      if (evt.target.nodeName === 'MODAL-DIALOG') this.hide();
      if (evt.target.classList.contains('modal')) this.hide();
    });

    document.addEventListener('keyup', (evt) => {
      if (evt.code.toUpperCase() === 'ESCAPE' && this.modal.classList.contains('open')) this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    setTimeout(() => {
      // Utility.trapFocus(this);
      Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
    }, 1500);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    // Utility.removeTrapFocus(this.openedBy);
    Utility.forceFocus(this.openedBy);

    if (this.querySelector('.modal-data')) this.querySelector('.modal-data').innerHTML = '';
    if (this.querySelector('.data-loader')) this.querySelector('.data-loader').classList.remove('d-none');
    this.dispatchEvent(new Event('modal:close'))
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
 * Quick add product
 */
class productQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.modalID = this.dataset.modalId;
    this.modal = document.querySelector(`#${this.modalID}`);

    this.triggerBtn = this.querySelector('[data-quickadd-trigger]');
    this.triggerBtn.addEventListener('click',this.handleModal.bind(this));
  }
  handleModal = async (event) => {
    event.preventDefault();
    this.modal.show(this.querySelector('button'));
    let productURL = this.triggerBtn.dataset.productHandle;
    let HTMLData = await this.quickAddHTML(productURL);
    let modalBody = this.modal.querySelector('.modal-body .modal-data');
    this.modal.querySelector('.data-loader')?.classList.add('d-none');
    modalBody.innerHTML = HTMLData;
    if (typeof skAnimation === "function") skAnimation();
      
    // Select and run script tags
    const scripts = modalBody.querySelectorAll('script:not([data-inventory])');
    for (let i = 0; i < scripts.length; i++) {
      eval(scripts[i]?.innerHTML);
    }
    window.photoswipeSimplify.init(window.pswp);
    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    if(modalBody.querySelector('product-model')){
      var script = document.createElement('script');
      script.src = "//sample.now/cdn/shop/t/40/assets/product-model.js?v=7010764627461616431785349510";
      script.defer = true;
      document.head.appendChild(script);
      setTimeout(() => {
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
      }, 600);
    }
  }
  quickAddHTML = async (productURL) => {
    let quickAddHTML = '';
    let url = `/products/${productURL}?view=quick-view`;
    await fetch(url,{method: "GET"})
    .then(res => res.text())
    .then(data => {
      let parser = new DOMParser();
      quickAddHTML = parser.parseFromString(data, "text/html");
      quickAddHTML = quickAddHTML.querySelector('main').innerHTML;
    })
    return quickAddHTML;
  };
}
customElements.define('product-quick-add', productQuickAdd);

/**
 * accordion functionality
 */
class accordionContent extends HTMLElement {
  constructor() {
    super();
    this.accordionItem = this.querySelectorAll('.accordion-item');
    this.toggleAccordion();
  }

  /**
   * toggle the accordions
   */
  toggleAccordion() {
    this.accordionItem?.forEach(accordion => {
      let title = accordion.querySelector('[data-accordion-title]');
      let contentEle = accordion.querySelector('[data-accordion-content]');

      title.addEventListener('click', (e) => {
        e.preventDefault();

        let contentHeight = Utility._getHeightofHiddenEle(contentEle);
        
        accordion.classList.toggle('open');
        if (accordion.classList.contains('open')) {
          contentEle.style.height = `0px`;
          accordion.classList.add('show');
          setTimeout(() => {
            contentEle.style.height = `${contentHeight}px`;
          }, 10);
          setTimeout(() => {
            contentEle.style.height = '';
          }, 350);
        } else {
          contentEle.style.height = `${contentHeight}px`;
          setTimeout(() => {
            contentEle.style.height = '0px';
          }, 10);
          setTimeout(() => {
            contentEle.style.height = '';
            accordion.classList.remove('show');
          }, 350);
        }
      })

    })
  }
}
customElements.define('accordion-content', accordionContent);

/**
 * custom dropdown
 */

class customDropdown extends HTMLElement{
  constructor() {
    super();
    this.dropDownContainer = this.querySelector('.custom-dropdown');
    this.selectionList = this.querySelector('ul');
    this.defaultOption = this.querySelector('.default-value');
    this.optionsList = this.selectionList.querySelectorAll('li');

    this.optionsList.forEach(el => el.addEventListener('click', this.toggleList.bind(this)));
    this.defaultOption.addEventListener('click', this.showHideSelect.bind(this));

    this.addEventListener('click', e => e.stopPropagation());
    document.body.addEventListener('click', () => Utility.toggleElement(this.dropDownContainer, 'close'));
  }

  /**
   * show hide custom dropdown
   * @param e 
   */
  toggleList(e){
    let eTarget = e.currentTarget;
    this.optionsList.forEach(el => el.classList.remove('selected'));
    eTarget.classList.add('selected');
    this.defaultOption.innerHTML = eTarget.querySelector('.default_text').innerHTML;
    eTarget.closest('.custom-dropdown').classList.add('selected');
    Utility.toggleElement(this.dropDownContainer, 'close');
  }

  /**
   * show hide custom dropdown
   * @param e 
   */
    showHideSelect(e){
      let isOpen = this.dropDownContainer.classList.contains('open');
      isOpen ? Utility.toggleElement(this.dropDownContainer, 'close') : Utility.toggleElement(this.dropDownContainer, 'open');
    }
}
customElements.define('custom-dropdown', customDropdown);

/**
 * Quantity Input 
 */

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);
/**
 * Sticky header
 */

class stickyHeader extends HTMLElement {
  constructor() {
    super();
    
    this.header = this.closest('.site-header');
    if(this.dataset.enableStickyHeader == 'true') {
      this.header?.classList.add('is-sticky');
    }
    this.headerHamburger = this.querySelector('[data-header-hamburger]');
    if(this.headerHamburger) {
      this.headerHamburger.addEventListener('click', this.handleDrawer.bind(this));
    }
  }
  connectedCallback() {
    if(this.dataset.stickyHeaderAlwaysVisible != 'true') {
      this.stickyOnScroll();
    }
  }

  handleClose(e) {
    e.preventDefault();
    this.header?.classList.remove('menu-open');
    document.body.classList.remove('scroll-fixed');
  }

  handleDrawer(e) {
    e.preventDefault();
    if(this.header?.classList.contains('menu-open')) {
      this.header?.classList.remove('menu-open');
      document.body.classList.remove('scroll-fixed');
    } else {
      this.header?.classList.add('menu-open');
      document.body.classList.add('scroll-fixed');
    }
  }


  stickyOnScroll() {
    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        let scrollTriggerOffset = this.header.clientHeight + 50; 
        if (scrollTop > scrollTriggerOffset) {
            document.body.classList.add('header-is-sticky');
            if (scrollTop < lastScrollTop) {
              document.body.classList.add('is-sticky-active');
            } else {
              document.body.classList.remove('is-sticky-active');
            }
        } else {
          document.body.classList.remove('header-is-sticky', 'is-sticky-active');
        }

        lastScrollTop = scrollTop;
    });
  }
}
customElements.define('sticky-header', stickyHeader);

class headerMenu extends stickyHeader {
  constructor() {
    super();
    
    this.headerClose = this.querySelector('[data-header-close]');
    this.headerMenuTrigger = this.querySelectorAll('[data-submenu-trigger]');
    this.onDocumentClick = this.handleDocumentClick.bind(this);

  }
  
  connectedCallback() {
    if(this.headerClose) {
      this.headerClose.addEventListener('click', super.handleClose.bind(this));
    }

    this.headerMenuTrigger?.forEach(ele => {
      ele.addEventListener('click', this.handleMenuTrigger.bind(this));
    });

    document.addEventListener('click', this.onDocumentClick, true);
    document.addEventListener('touchstart', this.onDocumentClick, true);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick, true);
    document.removeEventListener('touchstart', this.onDocumentClick, true);
  }

  handleMenuTrigger(e) {
    e.preventDefault();
    e.stopPropagation();

    let parentEle = e.currentTarget.closest('li');
    let triggerSubmenu = parentEle.querySelector('.megamenu-index, .menu-children-list, .link-level-3-list');

    parentEle.classList.toggle('open');
    if(parentEle.classList.contains('open')) {
      Utility.slideDown(triggerSubmenu, 250);
    } else {
      Utility.slideUp(triggerSubmenu, 250);
    }
  }

  handleDocumentClick(e) {
    // Ignore clicks inside the header menu
    if (this.contains(e.target)) return;

    const isHeaderOpen = this.header?.classList.contains('menu-open');
    const hasAnySubmenuOpen = this.querySelector('li.open') !== null;
    if (!isHeaderOpen && !hasAnySubmenuOpen) return;

    // Close all open submenus
    this.closeAllSubmenus();

    // Close header drawer if open
    if (isHeaderOpen) {
      super.handleClose(e);
    }
  }

  closeAllSubmenus() {
    const openItems = this.querySelectorAll('li.open');
    openItems.forEach((item) => {
      const submenu = item.querySelector('.megamenu-index, .menu-children-list, .link-level-3-list');
      if (submenu) {
        Utility.slideUp(submenu, 250);
      }
      item.classList.remove('open');
    });
  }

}
customElements.define('header-menu', headerMenu);

/**
 * Predictive search
 */
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.triggerBtns = document.querySelectorAll('.site-header a[href="/search"]');
    this.searchInput = this.querySelector('input[type="search"]');
    this.searchInputType = this.querySelector('input[name="resources[type]"]')?.value;
    this.searchInputLimit = this.querySelector('input[name="resources[limit]"]')?.value;
    this.searchClose = this.querySelector('.search-close');
    this.resultsEle = this.querySelector('#searchResults');
    this.typingTimeout = null;
    if (this.triggerBtns.length > 0) this.triggerBtns.forEach(btn => btn.addEventListener('click', this.openSearchBar.bind(this)));
    this.searchClose?.addEventListener('click', this.closeSearchBar.bind(this));
    this.formWrapper = this.querySelector('.form-wrapper');
    this.searchModalClose = this.querySelector('[data-search-modal-close]');
  }

  
  connectedCallback() {
    this.onInput();
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE' && document.body.classList.contains('search-bar-active')) this.closeSearchBar(),siteOverlay.prototype.hideOverlay()
    });
    this.formWrapper.addEventListener('click', this.openSearchModalWrapper.bind(this));
    this.searchModalClose?.addEventListener('click', this.closeSearchModalWrapper.bind(this));
  }
  
  openSearchModalWrapper(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    document.body.classList.add('search-bar-active');
    Utility.trapFocus(this);
    Utility.forceFocus(this.searchInput);
  }

  closeSearchModalWrapper(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    document.body.classList.remove('search-bar-active');
  }

  onInput() {
    this.searchInput.addEventListener('input', () => {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(() => this.handleSubmit(), 500);
    });
  }

  openSearchBar(event) {
    event.preventDefault();
    document.body.classList.add('search-bar-active');
    Utility.trapFocus(this);
    Utility.forceFocus(this.searchInput);
  }

  handleSubmit() {
    console.log('finished typing:', this.searchInput.value);
    if(this.searchInput.value != '') {
      fetch(`/search/suggest?q=${this.searchInput.value}&resources[type]=${this.searchInputType}&resources[limit]=${this.searchInputLimit}&resources[limit_scope]=each&section_id=predictive-search`)
      .then(res => res.text())
      .then(data => {
        this.resultsEle && (this.resultsEle.innerHTML = data);
        if (typeof skAnimation === "function") skAnimation();
      });

      Utility.slideDown(this.resultsEle);
    } else {
      Utility.slideUp(this.resultsEle);
      if(document.querySelector('.header-layout-menu_bottom')) {
      }
    }
    

  }
  closeSearchBar(event) {
    event?.preventDefault();
    document.body.classList.remove('search-bar-active');
    Utility.slideUp(this.resultsEle);
    this.searchInput.value = '';
    Utility.trapFocus(this);
    Utility.forceFocus(document.querySelector('.actions-wrapper ul > li > #searchBar'));
    // setTimeout(() => {
    //   this.resultsEle.innerHTML = '';
    // }, 400);
  } 
}
customElements.define('predictive-search', PredictiveSearch);


/**
 * Manage cookies
 */
class CookieJs {
  getCookie = (name) => {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }
  setCookie = (name, value, days) => {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  deleteCookie = (name) => { this.setCookie(name, '', -1); }
}
const cookieObj = new CookieJs;



if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.saveNoteBtn = this.querySelector('[data-save-note]');
        
        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
        this.saveNoteBtn?.addEventListener('click', this.saveNote.bind(this));
      }
      saveNote(event) {
        event.preventDefault();
        this.closest('[data-order-note-content]').classList.remove('open');
      }
    }
  );
}